import React, { Fragment } from 'react'
import {
  Location,
  LocationContainer,
  LocationLogo,
  LocationOrderStatus,
} from '../common/Location'
import { SimpleSpinner } from '../common/SimpleSpinner'

const ActiveOrderStatus = ({ order, statusText, loading, locationId }) => {
  return (
    <Fragment>
      {loading ? (
        <SimpleSpinner />
      ) : (
        <Location>
          <LocationContainer>
            <div className="row middle-xs">
              <div className="col-xs-6">
                <LocationLogo
                  logoAlt={`${order.storeName} logo`}
                  logoLink={order.logoUrl}
                />
              </div>
              <div className="col-xs-6">
                <LocationOrderStatus
                  locationId={locationId}
                  order={order}
                  showManage="true"
                  statusText={statusText}
                />
              </div>
            </div>
          </LocationContainer>
        </Location>
      )}
    </Fragment>
  )
}
export default ActiveOrderStatus
